import { axios } from '@/utils/request'

/**
 * 查询医生资质审核1
 *
 * @author liwei
 * @date 2022-04-16 15:50:26
 */
export function baDoctorCheckPage (parameter) {
  return axios({
    url: '/baDoctorCheck/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 医生资质审核1列表
 *
 * @author liwei
 * @date 2022-04-16 15:50:26
 */
export function baDoctorCheckList (parameter) {
  return axios({
    url: '/baDoctorCheck/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加医生资质审核1
 *
 * @author liwei
 * @date 2022-04-16 15:50:26
 */
export function baDoctorCheckAdd (parameter) {
  return axios({
    url: '/baDoctorCheck/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑医生资质审核1
 *
 * @author liwei
 * @date 2022-04-16 15:50:26
 */
export function baDoctorCheckEdit (parameter) {
  return axios({
    url: '/baDoctorCheck/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除医生资质审核1
 *
 * @author liwei
 * @date 2022-04-16 15:50:26
 */
export function baDoctorCheckDelete (parameter) {
  return axios({
    url: '/baDoctorCheck/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出医生资质审核1
 *
 * @author liwei
 * @date 2022-04-16 15:50:26
 */
export function baDoctorCheckExport (parameter) {
  return axios({
    url: '/baDoctorCheck/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
